import { type Event } from 'src/types'

export const eventData: Event[] = [
  {
    id: 'demo_intro',
    branches: [
      {
        id: 'start',
        title: 'Demo Introduction',
        logs: [
          {
            text: 'Welcome to Samsara! This is a demo of my rpg engine.',
            author: 'Nuno',
            omen: 'good'
          },
          {
            text: 'You can interact with objects and NPCs around you.',
            author: 'Nuno',
            omen: 'good'
          }
        ],
        options: [
          {
            text: 'Continue exploring',
            effects: {
              switches: {},
              counters: {},
              variables: {},
              items: {},
              location: '',
              fight: ''
            },
            end: true
          }
        ],
        conditions: {
          switches: {},
          counters: {},
          variables: {},
          items: {},
          locations: []
        },
        effects: {
          switches: {},
          counters: {},
          variables: {},
          items: {},
          location: '',
          fight: ''
        }
      }
    ],
    createdAt: Date.now(),
    isVerified: false
  },
  {
    id: 'walter_bridge',
    branches: [
      {
        id: 'first_meeting',
        title: 'Walter at the Bridge',
        conditions: {
          switches: { has_met_walter: false }
        },
        logs: [
          {
            text: 'Hey bud, glad to see you\'re awake.',
            author: 'Old Man',
            omen: 'good'
          },
          {
            text: 'Where am I?',
            author: 'Player',
            omen: 'special'
          },
          {
            text: 'You\'re in the tunnels, safest place in this part of town.',
            author: 'Old Man',
            omen: 'good'
          },
          {
            text: 'Who are you?',
            author: 'Player',
            omen: 'special'
          },
          {
            text: 'Name\'s Walter.',
            author: 'Walter',
            omen: 'good'
          }
        ],
        options: [
          {
            text: 'Nice to meet you, Walter.',
            effects: {
              switches: { has_met_walter: true }
            },
            end: true
          }
        ],
        effects: {
          switches: {},
          counters: {},
          variables: {},
          items: {},
          location: '',
          fight: ''
        }
      },
      {
        id: 'subsequent_meetings',
        title: 'Walter\'s Advice',
        conditions: {
          switches: { has_met_walter: true }
        },
        logs: [
          {
            text: 'Feel free to rest here whenever you want.',
            author: 'Walter',
            omen: 'good'
          },
          {
            text: 'Resting is how you get stronger, after a good fighting.',
            author: 'Walter',
            omen: 'special'
          }
        ],
        options: [
          {
            text: 'Thanks for the advice!',
            effects: {},
            end: true
          }
        ],
        effects: {
          switches: {},
          counters: {},
          variables: {},
          items: {},
          location: '',
          fight: ''
        }
      }
    ],
    createdAt: Date.now(),
    isVerified: false
  },
  {
    id: 'junker_intro',
    branches: [
      {
        id: 'start',
        title: 'Junker Introduction',
        logs: [
          {
            text: 'Hey! I\'m the Junker. I collect all sorts of interesting things.',
            author: 'Junker',
            omen: 'good'
          },
          {
            text: 'If you find anything valuable, bring it to me!',
            author: 'Junker',
            omen: 'good'
          }
        ],
        options: [
          {
            text: 'I\'ll keep that in mind!',
            effects: {
              switches: {},
              counters: {},
              variables: {},
              items: {},
              location: '',
              fight: ''
            },
            end: true
          }
        ],
        conditions: {
          switches: {},
          counters: {},
          variables: {},
          items: {},
          locations: []
        },
        effects: {
          switches: {},
          counters: {},
          variables: {},
          items: {},
          location: '',
          fight: ''
        }
      }
    ],
    createdAt: Date.now(),
    isVerified: false
  },
  {
    id: 'bed_rest',
    branches: [
      {
        id: 'rest',
        title: 'Rest and Recovery',
        logs: [
          {
            text: 'You lie down on the comfortable bed and close your eyes...',
            author: '',
            omen: 'good'
          },
          {
            text: 'After a peaceful rest, you feel refreshed and stronger.',
            author: '',
            omen: 'good'
          }
        ],
        options: [
          {
            text: 'Get up',
            effects: {
              switches: { is_resting: true },
              counters: {}
            },
            end: true
          }
        ],
        conditions: {
          switches: {},
          counters: {},
          variables: {},
          items: {},
          locations: []
        },
        effects: {
          switches: {},
          counters: {},
          variables: {},
          items: {},
          location: '',
          fight: ''
        }
      }
    ],
    createdAt: Date.now(),
    isVerified: false
  }
]

// Export removed - now using named export above
